var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConnectAgentCtaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 19.9993,
    r: 13.3333,
    fill: "#0ABAB5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55 73.3333C49.5003 73.3333 46.7505 73.3333 45.0419 71.6248C43.3334 69.9162 43.3334 67.1664 43.3334 61.6667C43.3334 56.1669 43.3334 53.4171 45.0419 51.7085C46.7505 50 49.5003 50 55 50C60.4998 50 63.2496 50 64.9582 51.7085C66.6667 53.4171 66.6667 56.1669 66.6667 61.6667C66.6667 67.1664 66.6667 69.9162 64.9582 71.6248C63.2496 73.3333 60.4998 73.3333 55 73.3333ZM61.5602 59.1527C62.3195 58.3934 62.3195 57.1622 61.5602 56.4028C60.8008 55.6435 59.5696 55.6435 58.8103 56.4028L52.4074 62.8057L51.1898 61.588C50.4304 60.8287 49.1993 60.8287 48.4399 61.588C47.6806 62.3474 47.6806 63.5785 48.4399 64.3379L51.0325 66.9305C51.7919 67.6898 53.023 67.6898 53.7824 66.9305L61.5602 59.1527Z",
    fill: "#0ABAB5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3824 45.0253C48.0154 43.9481 44.1332 43.334 40 43.334C27.1133 43.334 16.6666 49.3035 16.6666 56.6673C16.6666 63.8025 26.4748 69.6287 38.8071 69.9835C38.7166 69.5625 38.6467 69.1447 38.5915 68.7343C38.3326 66.8085 38.3329 64.4557 38.3333 61.9538V61.3807C38.3329 58.8789 38.3326 56.526 38.5915 54.6003C38.8796 52.4573 39.5682 50.1117 41.5064 48.1736C43.4445 46.2355 45.7901 45.5469 47.933 45.2588C48.9729 45.119 50.1373 45.0547 51.3824 45.0253Z",
    fill: "#0ABAB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectAgentCtaIcon);
export default __webpack_public_path__ + "static/media/connect-agent-cta-icon.404d127a742cd03f7255a06b6e3c94c1.svg";
export { ForwardRef as ReactComponent };